"use client"
import Image from "next/image"
import { useState, useRef, useEffect } from "react"
import { Form, Input, Select, message } from "antd"
import Button from "@/components/CommonComponent/button"
// import countryList from "world-countries-capitals"; // You can use an API or static data
import { useRouter } from "next/navigation"
import { FaArrowRightLong } from "react-icons/fa6"
import Script from "next/script"
declare global {
  interface Window {
    grecaptcha: any
  }
}
const Footerbanner = () => {
  const formRef = useRef<any>(null)
  const router = useRouter()
  const [phoneCode, setPhoneCode] = useState("")
  const [showToTop, setShowToTop] = useState(false)
  const handleSubmit = async (values: any) => {
    // console.log('values are ',values)
    if (!window.grecaptcha) {
      message.error("reCAPTCHA failed to load. Please refresh the page.")
      return
    }
    try {
      // Request a reCAPTCHA v3 token
      const token = await window.grecaptcha.execute("6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX", { action: "submit" })
      const selectedServices = Object.entries(values)
        .filter(([key, value]) => key.startsWith("service_") && value === true)
        .map(([key]) => key.replace("service_", ""))
        .join(";")
      const fullPhoneNumber = `${values.phoneCode}${values.phoneNumber}`
      // console.log('value',values)
      // console.log('fullPhoneNumber',fullPhoneNumber)
      if (values.phoneNumber.length !== 10) {
        message.error("Phone number must be exactly 10 digits!")
        return
      }
      const response = await fetch(
        "https://api.hsforms.com/submissions/v3/integration/submit/20095080/2a841ab2-9b37-41a6-a33e-6e1321aa9bff",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fields: [
              { name: "firstname", value: values.firstname },
              { name: "country", value: values.country },
              { name: "email", value: values.email },
              { name: "phone", value: fullPhoneNumber },
              { name: "lastname", value: values.lastname },
              {
                name: "monthly_spent_budget_for_digital_marketing",
                value: values.monthly_spent_budget_for_digital_marketing,
              },
              { name: "website", value: values.website },
              { name: "message", value: values.message },
            ],
          }),
        },
      )
      if (response.ok) {
        message.success("Form submitted successfully!")
        formRef.current.resetFields()
        router.push("/thank-you")
      } else {
        const errorData = await response.json()
        // console.error("Error submitting form:", errorData)
        message.error("Failed to submit form. Please try again.")
      }
    } catch (error) {
      console.error("Error submitting form:", error)
      message.error("An unexpected error occurred. Please try again.")
    }
  }
  // console.log('phone code is------------------',phoneCode)
  const countryData = [
    { name: "India", code: "+91" },
    { name: "United States", code: "+1" },
    { name: "United Kingdom", code: "+44" },
    { name: "Canada", code: "+1" },
    { name: "Australia", code: "+61" },
    { name: "Germany", code: "+49" },
    { name: "France", code: "+33" },
    { name: "China", code: "+86" },
    { name: "Japan", code: "+81" },
    { name: "Brazil", code: "+55" },
    { name: "Mexico", code: "+52" },
    { name: "South Africa", code: "+27" },
    { name: "Russia", code: "+7" },
    { name: "Italy", code: "+39" },
    { name: "Spain", code: "+34" },
    { name: "Netherlands", code: "+31" },
    { name: "Sweden", code: "+46" },
    { name: "Switzerland", code: "+41" },
    { name: "United Arab Emirates", code: "+971" },
    { name: "Saudi Arabia", code: "+966" },
    { name: "South Korea", code: "+82" },
    { name: "New Zealand", code: "+64" },
    { name: "Malaysia", code: "+60" },
    { name: "Singapore", code: "+65" },
  ]
  const images = [
    "/footer/footer1.png",
    "/footer/footer2.png",
    "/footer/footer3.png",
    "/footer/footer4.png",
    "/footer/footer5.png",
  ]
  // Calculate the current week number of the year
  const getWeekNumber = () => {
    const currentDate = new Date()
    const startOfYear = new Date(currentDate.getFullYear(), 0, 1)
    const days = Math.floor((currentDate.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000))
    return Math.ceil((days + startOfYear.getDay() + 1) / 7)
  }
  // Get the current week number
  const weekNumber = getWeekNumber()
  // const [showToTop, setShowToTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowToTop(window.scrollY > window.innerHeight / 10)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])
  // Calculate the image index based on the week number
  const imageIndex = (weekNumber - 1) % images.length
  return (
    <div className="w-full  border-t-[1px]">
      <Script
        src="https://www.google.com/recaptcha/api.js?render=6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX"
        strategy="lazyOnload"
        onLoad={() => {
          // console.log("reCAPTCHA script loaded successfully")
        }}
        onError={() => {
          message.error("Failed to load reCAPTCHA script. Please refresh the page.")
        }}
      />
      <div className="w-full mx-auto rounded-2xl pt-12 bg-lightblue bg-cover bg-center">
        <div className="w-full relative shadow rounded-2xl xl:w-[95%]  2xl:w-[75%] mx-auto bg-white flex justify-between items-center">
          <div className="bg-white md:w-[55%]  flex-col flex text-center md:text-left px-4 sm:px-12 py-10 md:py-0">
            <p className="text-homeblack font-semibold my-3 mb-5 lg:leading-[45px] text-[24px] lg:text-[34px]">
              Discover How We Can Help Your Business Grow.
            </p>
            <Form ref={formRef} layout="vertical" onFinish={handleSubmit} className="mx-auto  w-full">
              {/* First Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <Form.Item
                  name="firstname"
                  label="First Name"
                  rules={[{ required: true, message: "Please enter your First name!" }, { pattern: /^[A-Za-z\s]+$/, message: "Only alphabets are allowed!" }]}
                  className="w-full">
                  <Input
                    placeholder="E.g., John’s Coffee Shop"
                    className="rounded-lg border-gray-300  shadow-sm focus:ring-primary focus:border-primary"
                  />
                </Form.Item>
                <Form.Item
                  name="lastname"
                  label="Last Name"
                  rules={[{ required: true, message: "Please enter your last name!" }, { pattern: /^[A-Za-z\s]+$/, message: "Only alphabets are allowed!" }]}
                >
                  <Input placeholder="Enter last Name" />
                </Form.Item>
              </div>
              {/* Second Row */}
              <div className="grid grid-cols-1 -mt-3 md:grid-cols-2 gap-3">
                <Form.Item
                  name="email"
                  label="Email Address"
                  rules={[{ required: true, type: "email", message: "Please enter a valid email!" }]}
                >
                  <Input placeholder="E.g., john@doe.com" />
                </Form.Item>
                <Form.Item
                  name="monthly_spent_budget_for_digital_marketing"
                  label="Monthly Budget for Digital Marketing"
                  rules={[{ required: true, message: "Please enter your budget!" }, { pattern: /^[0-9]+$/, message: "Only numbers are allowed!" },
                  ]}
                >
                  <Input placeholder="E.g., $250" />
                </Form.Item>
              </div>
              <div className="grid grid-cols-1 -mt-3 md:grid-cols-2 gap-3">
                <Form.Item
                  name="country"
                  label="Country/Region"
                  rules={[{ required: true, message: "Please enter your Country" }]}
                >
                  <Input placeholder="E.g., India" />
                </Form.Item>
                <Form.Item
                  name="website"
                  label="Website URL"
                  rules={[
                    { required: true, message: "Please enter your Website URL!" },
                    {
                      pattern: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+)\.([a-zA-Z]{2,})(\/.*)?$/,
                      message: "Please enter a valid URL!"
                    }
                  ]}
                  className="w-full"
                >
                  <Input
                    placeholder="Enter your website URL (e.g., https://example.com)"
                    className="rounded-lg border-gray-300 shadow-sm focus:ring-primary focus:border-primary"
                  />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <Form.Item
                  name="phoneCode"
                  label="Phone Code"
                  rules={[{ required: true, message: "Please select a phone code!" }]}
                >
                  <Select
                    placeholder="Select phone code"
                    aria-label="Select phone code" // Add explicit ARIA label
                  >
                    {countryData.map((country) => (
                      <Select.Option key={country.code} value={country.code}>
                        {country.name} {country.code}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="phoneNumber"
                  label="Phone Number"
                  rules={[
                    { required: true, message: "Please enter your phone number!" },
                    { pattern: /^\d+$/, message: "Phone number must contain only digits!" },
                  ]}
                >
                  <Input
                    placeholder="Enter phone number"
                    aria-label="Enter phone number" // Add explicit ARIA label
                  />
                </Form.Item>
              </div>
              {/* Message Field */}
              <Form.Item
                name="message"
                label="Message"
                className="-mt-3"
                rules={[{ required: true, message: "Please enter your Message" }]}
              >
                <Input.TextArea placeholder="Enter your message" rows={3} />
              </Form.Item>
              {/* Submit Button */}
              <Form.Item className="mt-3">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="bg-red-500 hover:bg-red-600"
                  content="Request Quote"
                ></Button>
              </Form.Item>
            </Form>
            {/* <HubspotForm  portalId="20095080" formId={"2a841ab2-9b37-41a6-a33e-6e1321aa9bff"} region={'na1'}/> */}
          </div>
          <div className="rounded-2xl">
            <Image
              src={images[imageIndex] || "/placeholder.svg"}
              height={312}
              width={488}
              alt="w3era"
              className="hidden md:block rounded-r-2xl"
            />
          </div>
        </div>
      </div>
      <div className="w-full bg-blue -mt-[400px] min-h-[450px]"></div>
      {showToTop && (
        <div
          className="border-2 zoom-in-out group border-slate-400 rotate-[270deg] fixed bottom-16 z-[150] right-12 bg-lightblue rounded-full flex gap-2 justify-center cursor-pointer items-center p-4 py-2"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth", // Smooth scroll effect
            })
          }
        >
          To Top
          <FaArrowRightLong className="text-[20px] group-hover:translate-x-1 duration-200" />
        </div>
      )}
    </div>
  )
}
export default Footerbanner

